// Shop-timezone helper for the customer convenience "add to calendar" links.
// This mirrors the server's logic in functions/src/ics.ts so the .ics the
// customer downloads matches the authoritative invite emailed by the function,
// regardless of the customer's own browser timezone.

import { pad } from "./time";

function tzOffsetMs(at: Date, timeZone: string): number {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone, hour12: false,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
  const map: Record<string, number> = {};
  for (const p of dtf.formatToParts(at)) {
    if (p.type !== "literal") map[p.type] = Number(p.value);
  }
  const hour = map.hour === 24 ? 0 : map.hour;
  const asUtc = Date.UTC(map.year, map.month - 1, map.day, hour, map.minute, map.second);
  return asUtc - at.getTime();
}

// Wall-clock time in a timezone to the matching UTC instant.
export function zonedWallTimeToUtc(
  year: number, month: number, day: number, minutes: number, timeZone: string,
): Date {
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  const naiveUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
  let offset = tzOffsetMs(new Date(naiveUtc), timeZone);
  offset = tzOffsetMs(new Date(naiveUtc - offset), timeZone);
  return new Date(naiveUtc - offset);
}

// UTC stamp in iCalendar basic format: YYYYMMDDTHHMMSSZ.
export function toUtcStamp(d: Date): string {
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
    `T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
}
